import React from 'react'

import { IProps } from './IProps'
import { NavContainer, NavSlot, NavLink, MenuImg } from './style'

export const RightSideNavigation = ({
  userData,
  toggleModal,
  activeUser,
}: IProps) => {
  const selectUser = (user: {
    uuid: string
    firstName: string
    lastName: string
  }) => {
    activeUser(user)
  }

  const mappedLinks = userData.map((data, i) => {
    const CurrentLink = () => {
      return (
        <NavSlot key={`navSlot${i}`}>
          <NavLink onClick={() => selectUser(data)}>
            <MenuImg src={`${data.avatar}&w=50&h=50&fit=crop`} />
          </NavLink>
        </NavSlot>
      )
    }
    return <CurrentLink key={`currentLink${i}`} />
  })

  return <NavContainer>{mappedLinks.map(link => link)}</NavContainer>
}
